const UA = navigator.userAgent;
const reg = UA.indexOf('Chrome') != -1 ? /(Chrome)\/(\d+)/i : /(Firefox|Chrome|Version|Opera)\/(\d+)/i;
const version = UA.match(reg);
export function isSupported(checkList) {
    return version && (parseInt(version[2]) >= checkList[version[1]]);
}
